{
  "language_toggle": {
    "label": "Language"
  },
  "common": {
    "studyfit": "StudyFit",
    "studyfitInc": "StudyFit Inc",
    "loading": "Loading...",
    "saving": "Saving...",
    "save": "Save",
    "cancel": "Cancel",
    "edit": "Edit",
    "delete": "Delete",
    "remove": "Remove",
    "back": "Back",
    "continue": "Continue",
    "submit": "Submit",
    "search": "Search",
    "create": "Create",
    "add": "Add",
    "view": "View",
    "viewAll": "View all",
    "close": "Close",
    "confirm": "Confirm",
    "copied": "Copied",
    "copy": "Copy",
    "processing": "Processing...",
    "uploading": "Uploading...",
    "download": "Download",
    "print": "Print",
    "or": "or",
    "of": "of",
    "more": "more",
    "noResults": "No results found",
    "name": "Name",
    "email": "Email",
    "role": "Role",
    "notSet": "Not set",
    "memberSince": "Member since",
    "unit": "unit",
    "units": "units",
    "lesson": "lesson",
    "lessons": "lessons",
    "student": "student",
    "students": "students",
    "activity": "activity",
    "activities": "activities",
    "question": "question",
    "questions": "questions",
    "session": "session",
    "sessions": "sessions",
    "words": "words",
    "min": "min",
    "pages": "pages",
    "completed": "Completed",
    "active": "Active",
    "draft": "Draft",
    "archived": "Archived",
    "ready": "Ready",
    "scheduled": "scheduled",
    "available": "Available",
    "locked": "Locked",
    "inProgress": "In Progress",
    "complete": "complete",
    "selectAll": "Select All",
    "deselectAll": "Deselect All",
    "clear": "Clear",
    "networkError": "Network error. Please try again.",
    "chapter": "chapter",
    "chapters": "chapters",
    "collapsePanel": "Collapse panel",
    "failed": "Failed",
    "begin": "Begin",
    "viewResults": "View Results"
  },
  "nav": {
    "dashboard": "Dashboard",
    "courses": "Courses",
    "library": "Library",
    "dictionary": "Dictionary",
    "atlas": "Atlas",
    "atlasMapSets": "Map Sets",
    "calendar": "Calendar",
    "sentenceStudio": "Sentence Studio",
    "assessments": "Assessments",
    "users": "Users",
    "liveSession": "Live Session",
    "essayComposer": "Essay Composer",
    "concepts": "Concepts",
    "tasks": "Tasks",
    "graphingCalculator": "Graphing Calculator",
    "activityGenerator": "Activity Generator",
    "vocabulary": "Vocabulary",
    "expandSidebar": "Expand sidebar",
    "collapseSidebar": "Collapse sidebar",
    "collapse": "Collapse",
    "logIn": "Log in",
    "logOut": "Log out",
    "profile": "Profile",
    "teacher": "Teacher",
    "stopImpersonating": "Stop impersonating",
    "impersonating": "Impersonating {{name}} ({{role}}). Signed in as {{trueName}}."
  },
  "auth": {
    "signIn": "Sign In",
    "signingIn": "Signing in...",
    "register": "Register",
    "createTeacherAccount": "Create your teacher account",
    "firstName": "First name",
    "firstNamePlaceholder": "Jane",
    "lastName": "Last name",
    "lastNamePlaceholder": "Smith",
    "preferredName": "Preferred name",
    "preferredNamePlaceholder": "What should we call you?",
    "email": "Email",
    "emailPlaceholder": "you@school.edu",
    "password": "Password",
    "passwordHint": "At least 8 characters",
    "confirmPassword": "Confirm password",
    "confirmPasswordPlaceholder": "Confirm your password",
    "creatingAccount": "Creating account...",
    "createAccount": "Create account",
    "alreadyHaveAccount": "Already have an account?",
    "areYouStudent": "Are you a student?",
    "joinWithCode": "Join with a code",
    "studentJoinWithCode": "Student? Join with a code",
    "signInHere": "Sign in here"
  },
  "join": {
    "joinLesson": "Join a lesson",
    "joinCode": "Join Code",
    "joinCodePlaceholder": "ABC123",
    "joinCodeHelp": "Enter the 6-character code from your teacher",
    "yourName": "Your Name (optional)",
    "namePlaceholder": "What should we call you?",
    "joining": "Joining...",
    "joinSession": "Join Session",
    "areYouTeacher": "Are you a teacher?",
    "pleaseEnterCode": "Please enter a join code",
    "invalidCode": "Invalid join code. Please check and try again.",
    "sessionClosed": "This session is no longer accepting participants."
  },
  "profile": {
    "title": "Profile",
    "subtitle": "Your account information",
    "emailPlaceholder": "you@example.com",
    "gradeLevel": "Grade level",
    "avatarColor": "Avatar color",
    "avatarColorHint": "Pick a color for your initials avatar.",
    "calendarSubscription": "Calendar Subscription",
    "calendarSyncDescription": "Sync your lesson schedule with Apple Calendar, Google Calendar, or Outlook.",
    "feedUrl": "Feed URL",
    "regenerateLink": "Regenerate Link",
    "privateTokenWarning": "This link contains a private token. Don't share it publicly.",
    "generateCalendarLink": "Generate Calendar Link",
    "calendarLinkGenerated": "Calendar link generated",
    "calendarLinkRegenerated": "Calendar link regenerated. Old links will stop working.",
    "learningProgress": "Learning Progress",
    "activitiesCompleted": "Activities completed",
    "wordsMastered": "Words mastered",
    "streakDays": "Day streak",
    "sentencesAnalyzed": "Sentences analyzed",
    "wordsInReview": "Words in review",
    "wordsOnboarding": "Words learning",
    "enrolledCourses": "Enrolled Courses",
    "recentSessions": "Recent Sessions",
    "noRecentSessions": "No completed sessions yet.",
    "noEnrolledCourses": "Not enrolled in any courses yet."
  },
  "studentDashboard": {
    "welcomeBack": "Welcome back,",
    "continueWhereLeftOff": "Continue where you left off",
    "yourCourses": "Your Courses",
    "noCourses": "No courses yet",
    "noCoursesHelp": "Ask your teacher for a course enrollment code to get started.",
    "continueLearning": "Continue Learning",
    "review": "Review",
    "yourSkills": "Your Skills",
    "skillsHelp": "Complete practice sessions to start tracking your skills",
    "moreSkills": "more skills",
    "vocabulary": "Vocabulary",
    "vocabComingSoon": "Vocabulary tracking coming soon",
    "vocabReviewDue_one": "{{count}} word ready for review",
    "vocabReviewDue_other": "{{count}} words ready for review",
    "vocabOnboardingPending_one": "{{count}} new word to learn",
    "vocabOnboardingPending_other": "{{count}} new words to learn",
    "studyVocabulary": "Study vocabulary",
    "vocabPracticeNow": "Practice now",
    "vocabAllCaughtUp": "You're all caught up",
    "vocabAcrossCourses_one": "{{count}} word across your courses",
    "vocabAcrossCourses_other": "{{count}} words across your courses",
    "vocabMastered": "Mastered",
    "vocabLearning": "Learning",
    "vocabNew": "New",
    "lessonsComplete": "{{completed}} of {{total}} complete"
  },
  "studentActivities": {
    "yourActivities": "Your Activities",
    "subtitle": "Track your progress through available activities",
    "noActivities": "No activities available",
    "noActivitiesHelp": "Check back soon for new activities to practice."
  },
  "studentCourse": {
    "upNext": "Up next",
    "noLessonsYet": "No lessons in this unit yet.",
    "noUnitsYet": "This course doesn't have any units yet.",
    "comingSoon": "Coming soon",
    "unitProgress_one": "{{completed}} of {{count}} lesson complete",
    "unitProgress_other": "{{completed}} of {{count}} lessons complete"
  },
  "studentVocab": {
    "myVocabulary": "My Vocabulary",
    "youHave": "You have",
    "word": "word",
    "dueForReview": "due for review",
    "practiceTitle": "Practice makes permanent",
    "studyNow": "Study now",
    "myWords": "My Words",
    "assigned": "Assigned",
    "noWordsYet": "No words yet. Add words by selecting text in any reading.",
    "noAssignedWords": "No assigned words yet."
  },
  "practice": {
    "step1of3": "Step 1 of 3",
    "step2of3": "Step 2 of 3",
    "step3of3": "Step 3 of 3",
    "step3Feedback": "Step 3 of 3 — Feedback",
    "reading": "Reading",
    "questions": "Questions",
    "reviewLabel": "Review",
    "saveAndExit": "Save & Exit",
    "backToDashboard": "Back to Dashboard",
    "backToReading": "Back to Reading",
    "backToResults": "Back to Results",
    "analyzingResponses": "Analyzing your responses...",
    "readingResponses": "Reading your responses...",
    "practiceComplete": "Practice Complete!",
    "greatEffort": "Great effort! Here's your personalized feedback.",
    "heresFeedback": "Here's your personalized feedback.",
    "skillsOverview": "Skills Overview",
    "demonstrated": "demonstrated",
    "continueToPractice": "Continue to Practice Exercises",
    "correct": "correct",
    "incorrect": "incorrect",
    "pendingReview": "pending review",
    "answered": "answered",
    "typeAnswerHere": "Type your answer here...",
    "writeResponseHere": "Write your response here...",
    "writeEssayHere": "Write your essay here...",
    "preferHandwriting": "Prefer handwriting?",
    "uploadHandwritten": "Upload a photo of your handwritten response instead",
    "submittingResponses": "Submitting responses...",
    "takeYourTime": "Take your time with the reading",
    "considerPrinting": "Consider printing this out or finding a quiet space. Deep reading leads to deeper understanding.",
    "finishedReading": "I've Finished Reading",
    "readInPeace": "Go and read in peace.",
    "comeBackWhenDone": "Come back when you are done.",
    "doneReading": "I'm done reading",
    "takeTimeReading": "Take your time reading",
    "step": "Step",
    "exercise": "Exercise",
    "readPassage": "Read this passage:",
    "exerciseIntro": "Based on your responses, let's practice strengthening this skill.",
    "checking": "Checking...",
    "checkAnswer": "Check Answer",
    "finish": "Finish",
    "nextExercise": "Next Exercise"
  },
  "practiceChoose": {
    "title": "Your Reading Assignment",
    "subtitle": "Choose how you'd like to read today",
    "researchShows": "Research shows that",
    "how": "how",
    "you": "you",
    "what": "what",
    "youRemember": "you remember.",
    "noWrongChoice": "There's no wrong choice—the best medium depends on your goals for this reading.",
    "printTitle": "Print & Read Offline",
    "printDescription": "Download the PDF to print or read on a dedicated device away from distractions.",
    "deeperProcessing": "Deeper Cognitive Processing",
    "deeperProcessingDesc": "Fixed text locations help your brain build a 'mental map' of the information, improving retention of specific details.",
    "betterCalibration": "Better Calibration",
    "betterCalibrationDesc": "Print readers are more accurate at predicting their actual comprehension—you'll know what you really learned.",
    "fewerDistractions": "Fewer Distractions",
    "fewerDistractionsDesc": "The 'stillness' of print reduces the urge to multitask or check notifications.",
    "bestFor": "Best for:",
    "deepStudy": "Deep study of complex information",
    "longTexts": "Long or technical texts",
    "rememberDetails": "When you need to remember details",
    "downloadPdf": "Download PDF",
    "minRead": "min read",
    "screenTitle": "Read On Screen",
    "screenDescription": "Read directly in the app with interactive features and instant access to questions.",
    "fasterNavigation": "Faster Navigation",
    "fasterNavigationDesc": "Quickly scan to find main ideas, search for keywords, and jump between sections.",
    "interactiveFeatures": "Interactive Features",
    "interactiveFeaturesDesc": "Seamless transition to questions with immediate feedback and integrated assessments.",
    "agileLearning": "Agile Learning",
    "agileLearningDesc": "Best for quick comprehension tasks where you need the gist rather than memorizing details.",
    "quickScanning": "Quick scanning for main ideas",
    "interactiveLearning": "Interactive learning with feedback",
    "shorterTexts": "Shorter or familiar texts",
    "beginReading": "Begin Reading"
  },
  "teacherDashboard": {
    "welcome": "Welcome,",
    "teacher": "Teacher",
    "subtitle": "Manage your activities and track student progress",
    "readyToTeach": "Ready to teach?",
    "readyToTeachDesc": "Create an activity and go live in minutes.",
    "startNow": "Start now",
    "totalActivities": "Total Activities",
    "activeSessions": "Active Sessions",
    "totalStudents": "Total Students",
    "studentsWorkingNow": "Students are working on these right now",
    "yourCourses": "Your Courses",
    "standaloneLessons": "Standalone Lessons",
    "standaloneLessonsDesc": "Lessons not attached to any course",
    "yourActivities": "Your Activities",
    "newActivity": "New Activity",
    "noActivities": "No activities yet",
    "noActivitiesHelp": "Create your first activity to get started. Drop in a reading, video, or any stimulus and let AI help draft your questions.",
    "createFirstActivity": "Create your first activity",
    "studentsJoined": "students joined",
    "joinCode": "Join code"
  },
  "teacherActivities": {
    "title": "Activities",
    "subtitle": "Create and manage your activity content",
    "newActivity": "New Activity",
    "noActivities": "No activities yet",
    "noActivitiesHelp": "Create your first activity to get started. Add a reading, video, or any stimulus and let AI help draft questions.",
    "createFirstActivity": "Create your first activity",
    "drafts": "Drafts",
    "draftsDesc": "Activities in progress",
    "ready": "Ready",
    "readyDesc": "Ready to use in sessions",
    "active": "Active",
    "activeDesc": "Currently in use",
    "questionsApproved": "questions approved"
  },
  "teacherActivityNew": {
    "title": "New Activity",
    "untitled": "Untitled Activity",
    "stimulusHeading": "Teaching Materials (Stimulus)",
    "stimulusDescription": "The content students will read and respond to.",
    "contentType": "Content Type",
    "bookChapter": "Book Chapter",
    "pdfDocument": "PDF Document",
    "urlLink": "URL / Link",
    "video": "Video",
    "articleText": "Article / Text",
    "articlePlaceholder": "Paste or type your article text here...",
    "videoPlaceholder": "Paste a YouTube, Vimeo, or other video URL",
    "urlPlaceholder": "Paste a link to an article or webpage",
    "imagePlaceholder": "Paste an image URL",
    "pdfDropzone": "Drop a PDF here or click to upload",
    "pdfLimit": "PDF files up to 10MB",
    "sourceTitle": "Source Title (optional)",
    "sourceTitlePlaceholder": "e.g., The Declaration of Independence",
    "activityDetails": "Activity Details",
    "objectives": "Objectives",
    "objectivesPlaceholder": "Brief description of what students will learn...",
    "objectivesHelp": "Optional. Helps you organize your activities.",
    "creating": "Creating...",
    "createActivity": "Create Activity",
    "nextGenerateQuestions": "Next: Generate and review questions",
    "removeFile": "Remove file",
    "clickToChangeFile": "Click to change file",
    "analyzingContent": "Analyzing content...",
    "extractingTitle": "Extracting source title...",
    "generatingTitle": "Generating activity title...",
    "suggestingObjectives": "Suggesting objectives...",
    "readingPdf": "Reading PDF...",
    "extractingText": "Extracting text...",
    "processingPages": "Processing pages..."
  },
  "teacherCourses": {
    "title": "Courses",
    "subtitle": "Organize your teaching into courses, units, and lessons",
    "startNow": "Start now",
    "newCourse": "New Course",
    "noCourses": "No courses yet",
    "noCoursesHelp": "Create your first course to start organizing your activities into a structured curriculum.",
    "createCourse": "Create a Course"
  },
  "teacherCourseNew": {
    "title": "New Course",
    "subtitle": "Create a new course to organize your teaching",
    "backToCourses": "Back to courses",
    "titleField": "Title",
    "description": "Description",
    "startDate": "Start Date",
    "endDate": "End Date",
    "titlePlaceholder": "e.g., English 101 — Spring 2026",
    "descriptionPlaceholder": "Brief description of this course...",
    "creating": "Creating...",
    "createCourse": "Create Course"
  },
  "teacherCourseEdit": {
    "title": "Edit Course",
    "backToCourse": "Back to course",
    "titleField": "Title",
    "description": "Description",
    "startDate": "Start Date",
    "endDate": "End Date",
    "saveChanges": "Save Changes",
    "deleteCourse": "Delete Course",
    "deleteWarning": "Permanently delete this course and all its units and lessons.",
    "deleteConfirm": "Delete this course? All units and lessons within it will also be deleted. This cannot be undone."
  },
  "teacherCourseShow": {
    "editCourse": "Edit Course",
    "backToCourses": "Back to courses",
    "studentsEnrolled": "students enrolled",
    "books": "Books",
    "chapters": "chapters",
    "passages": "passages",
    "assignedToUnit": "Assigned to unit",
    "addUnit": "Add Unit",
    "noUnits": "No units yet",
    "noUnitsHelp": "Add your first unit to start organizing lessons within this course.",
    "addAUnit": "Add a Unit",
    "noUnitsDrag": "No units yet. Drag a book above or click Add Unit to get started.",
    "planChapters": "Plan Chapters",
    "assignChapters": "Assign chapters to lessons",
    "noLessons": "No lessons in this unit yet.",
    "addLesson": "Add a Lesson",
    "addLessonShort": "Add Lesson",
    "searchStudents": "Search students by name or email...",
    "noStudentsFound": "No students found",
    "noStudentsEnrolled": "No students enrolled yet. Search above to add students.",
    "removeStudent": "Remove student",
    "addAnotherBook": "Add another book",
    "dropFileHere": "Drop a file here to add reading materials",
    "dragBookToCreate": "Drag a book to the drop zone below to create a unit",
    "creatingUnit": "Creating unit...",
    "dropBookHere": "Drop a book here to create a unit"
  },
  "teacherCourseVocab": {
    "assignedLists": "Assigned Lists",
    "assignList": "Assign List",
    "assignListPlus": "+ Assign List",
    "searchSystemLists": "Search system lists...",
    "noMatchingLists": "No matching lists",
    "noSystemLists": "No system lists assigned. Assign AWL, frequency, or test prep lists to push words to enrolled students.",
    "unassignList": "Unassign list",
    "courseWordList": "Course Word List",
    "noWordsYet": "No words yet. Add words from chapter suggestions below to get started.",
    "pos": "POS",
    "frequency": "Frequency",
    "context": "Context",
    "removeWord": "Remove word",
    "vocabFromReadings": "Vocabulary from Readings",
    "vocabFromReadingsDesc": "Pre-computed vocabulary suggestions from books attached to this course.",
    "loadingChapters": "Loading chapter suggestions...",
    "noBooksAttached": "No books are attached to this course yet. Add a book to the course to see vocabulary suggestions.",
    "noChapterSuggestions": "No chapter suggestions are available yet. You can still search the book above.",
    "suggestions": "suggestions",
    "alreadyAdded": "Already added",
    "wordsSelected": "words selected",
    "addWords": "Add Words",
    "addingWords": "Adding words...",
    "word": "Word",
    "findContext": "Find a context in the book",
    "findContextDesc": "Search the whole book, compare occurrences across chapters, then choose the context students will see.",
    "chooseBook": "Choose a book",
    "searchBookPlaceholder": "Search for a word…",
    "searchFailed": "The book search could not be completed. Please try again.",
    "noBookMatches": "No occurrences of that word or its related forms were found in this book.",
    "occurrencesFound_one": "{{count}} occurrence in this book",
    "occurrencesFound_other": "{{count}} occurrences in this book",
    "relatedForm": "related form: {{word}}",
    "useThisContext": "Use this context",
    "contextAdded": "Added {{word}} with the selected context.",
    "wordWasAlreadyAdded": "{{word}} is already in the course list; its existing context was kept.",
    "addFailed": "The word could not be added. Please try again.",
    "addingProgress": "Adding {{current}} of {{total}} words…",
    "addedCount_one": "Added {{count}} word successfully.",
    "addedCount_other": "Added {{count}} words successfully.",
    "switchForm": "Switch form",
    "noRelatedForms": "No related forms"
  },
  "teacherLessons": {
    "editLesson": "Edit Lesson",
    "newLesson": "New Lesson",
    "backToLesson": "Back to lesson",
    "backTo": "Back to",
    "titleField": "Title",
    "description": "Description",
    "titlePlaceholder": "e.g., Lesson 1: Introduction to Persuasion",
    "descriptionPlaceholder": "What students will do in this lesson...",
    "lessonType": "Lesson Type",
    "typeReading": "Reading",
    "typeWriting": "Writing",
    "typeVocabulary": "Vocabulary",
    "typeGrammar": "Grammar",
    "typeMixed": "Mixed",
    "scheduledDateTime": "Scheduled Date & Time",
    "durationMinutes": "Duration (minutes)",
    "endsAt": "Ends at",
    "location": "Location",
    "locationPlaceholder": "Room number, building, or Zoom link",
    "creating": "Creating...",
    "createLesson": "Create Lesson",
    "saveChanges": "Save Changes",
    "deleteLesson": "Delete Lesson",
    "deleteWarning": "Permanently delete this lesson.",
    "deleteConfirm": "Delete this lesson? This cannot be undone.",
    "assignedActivities": "Assigned Activities"
  },
  "teacherAssessments": {
    "title": "Assessments",
    "noAssessments": "No assessments yet. Run",
    "seedCommand": "rails vst:generate",
    "seedSuffix": "to seed the Vocabulary Size Test.",
    "itemsInBank": "items in bank",
    "completedAdministrations": "completed administrations",
    "tryIt": "Try It",
    "tryItPreview": "Try It (Preview)",
    "totalItems": "total items",
    "completions": "completions",
    "itemBankByBand": "Item Bank by Band",
    "band": "Band",
    "items": "Items",
    "studentResults": "Student Results",
    "noStudentResults": "No student has completed this assessment yet.",
    "vocabSize": "Vocab Size",
    "gradeLevel": "Grade Level",
    "duration": "Duration",
    "date": "Date"
  },
  "teacherAssessmentResults": {
    "results": "Results",
    "previewNote": "Preview mode — these results were not saved.",
    "yourResults": "Your Results",
    "estimatedWordFamilies": "estimated word families",
    "readingLevel": "Reading level:",
    "completedIn": "Completed in",
    "bandBreakdown": "Band Breakdown",
    "score": "Score",
    "accuracy": "Accuracy",
    "total": "Total",
    "questionReview": "Question Review",
    "backToAssessment": "Back to Assessment",
    "allAssessments": "All Assessments"
  },
  "teacherCalendar": {
    "title": "Calendar",
    "subscribe": "Subscribe",
    "today": "Today",
    "month": "Month",
    "week": "Week",
    "openLesson": "Open lesson",
    "previousMonth": "Previous month",
    "nextMonth": "Next month",
    "previousWeek": "Previous week",
    "nextWeek": "Next week",
    "subscribeTitle": "Subscribe to Calendar",
    "syncDescription": "Sync your StudyFit schedule with Apple Calendar, Google Calendar, Outlook, or any app that supports iCal subscriptions.",
    "hideInstructions": "Hide instructions",
    "howToSubscribe": "How to subscribe",
    "tokenWarning": "This link contains a private token. Don't share it publicly. If compromised, click Regenerate Link to create a new one.",
    "generateHelp": "Generate a calendar subscription link to get started.",
    "howToSubscribeTitle": "How to Subscribe",
    "appleCal": "Apple Calendar (macOS / iOS)",
    "appleStep1": "Open the Calendar app",
    "appleStep2": "Go to File → New Calendar Subscription",
    "appleStep3": "Paste the feed URL and click Subscribe",
    "appleStep4": "Choose your refresh interval and click OK",
    "googleCal": "Google Calendar",
    "googleStep1": "Open Google Calendar in a browser",
    "googleStep2": "Click the + next to \"Other calendars\"",
    "googleStep3": "Select \"From URL\"",
    "googleStep4": "Paste the feed URL and click \"Add calendar\"",
    "outlookCal": "Microsoft Outlook",
    "outlookStep1": "Open Outlook Calendar",
    "outlookStep2": "Click \"Add calendar\" → \"Subscribe from web\"",
    "outlookStep3": "Paste the feed URL and give it a name",
    "outlookStep4": "Click \"Import\""
  },
  "teacherLibrary": {
    "title": "Library",
    "subtitle": "Upload books, PDFs, presentations, or save links",
    "uploadFile": "Upload File",
    "saveLink": "Save Link",
    "searchPlaceholder": "Search by title or author...",
    "unsupportedFile": "Please select an EPUB, PDF, or PPTX file",
    "processingItems": "Items being analyzed",
    "readyItems": "Items available for search",
    "failedItems": "Items that couldn't be processed",
    "dropFile": "Drop a file here to add reading materials",
    "addAnotherBook": "Add another book",
    "dragToCreate": "Drag a book to the drop zone below to create a unit",
    "dropHere": "Drop an EPUB, PDF, or PPTX here or click to browse",
    "addFirstItem": "Add your first item",
    "addFirstItemHelp": "Drop an EPUB, PDF, or PPTX file here. AI-powered semantic search helps you find relevant passages instantly.",
    "processingUpload": "Processing upload...",
    "chooseFile": "Choose File",
    "backToDictionary": "Back to Dictionary",
    "usedIn": "Used in:",
    "searchPassages": "Search passages...",
    "tableOfContents": "Table of Contents",
    "previousPage": "Previous page",
    "nextPage": "Next page",
    "page": "Page",
    "searchForPassages": "Search for passages or select a chapter",
    "searchToStart": "Search for passages to get started",
    "partOf": "Part of {{series}}"
  },
  "teacherLibraryEdit": {
    "editItem": "Edit Item",
    "titleField": "Title",
    "author": "Author",
    "authorPlaceholder": "Author name (optional)",
    "category": "Category",
    "noCategory": "No category",
    "url": "URL",
    "type": "Type:",
    "language": "Language:",
    "saveChanges": "Save Changes",
    "viewContent": "View content",
    "toReference": "to reference while editing",
    "cantDelete": "This item can't be deleted because it's used in",
    "activeCourse": "an active course",
    "activeCourses": "active courses",
    "deleteItem": "Delete Item"
  },
  "teacherProfile": {
    "title": "Profile",
    "subtitle": "Your account information"
  },
  "teacherSessions": {
    "addStimulusFirst": "Add a stimulus and approve at least one question first",
    "couldNotCreate": "Could not create session",
    "sessionActive": "Session is now active",
    "sessionCompleted": "Session completed"
  },
  "dictionary": {
    "title": "Dictionary",
    "vocabDictionary": "Vocabulary Dictionary",
    "explore": "Explore",
    "wordsWithDefs": "words with definitions, morphology, and word families",
    "words": "Words",
    "definitions": "Definitions",
    "morphemes": "Morphemes",
    "wordFamilies": "Word Families",
    "vocabularyLists": "Vocabulary Lists",
    "searchResults": "Search Results",
    "found": "found",
    "noWordsFound": "No words found matching",
    "tryDifferent": "Try a different spelling or browse the featured words below",
    "rareWords": "Rare Words",
    "rareWordsDesc": "Uncommon vocabulary worth discovering",
    "browseByCategory": "Browse by Category",
    "byFrequencyBand": "By Frequency Band",
    "frequencyBandDesc": "Words grouped by how commonly they appear in English",
    "byBeckTier": "By Beck Tier",
    "beckTierDesc": "Words categorized by instructional importance",
    "backToDictionary": "Back to Dictionary",
    "morphemeBreakdown": "Morpheme Breakdown",
    "wordFamily": "Word Family",
    "relatedWords": "Related Words",
    "synonyms": "Synonyms",
    "antonyms": "Antonyms",
    "browseMoreWords": "Browse More Words",
    "viewVocabLists": "View Vocabulary Lists",
    "dictionaryDataFrom": "Dictionary data from",
    "openEnglishWordNet": "Open English WordNet",
    "ccBy4": "(CC BY 4.0) and",
    "wiktionary": "Wiktionary",
    "ccBySa3": "(CC BY-SA 3.0)",
    "addToClassList": "Add to class list",
    "addedTo": "Added to",
    "noDefinitions": "No definitions available.",
    "matchesYourContext": "The meaning in your sentence",
    "searchPlaceholder": "Search for a word...",
    "searching": "Searching...",
    "wordsWith": "Words with",
    "headword": "Headword:",
    "family": "Family: {{headword}}",
    "exampleSentences": "Example Sentences",
    "aiGenerated": "AI-generated"
  },
  "morphemes": {
    "prefix": "prefix",
    "root": "root",
    "suffix": "suffix",
    "bound": "bound",
    "infix": "infix"
  },
  "frequency": {
    "top1k": "Top 1K",
    "top2k": "Top 2K",
    "top3k": "Top 3K",
    "top5k": "Top 5K",
    "top10k": "Top 10K",
    "rare": "Rare",
    "scoreLabel": "Frequency score: {{score}} (Zipf scale)"
  },
  "pos": {
    "noun": "noun",
    "verb": "verb",
    "adj": "adj",
    "adv": "adv",
    "prep": "prep",
    "conj": "conj",
    "pron": "pron",
    "det": "det",
    "interj": "interj"
  },
  "tier": {
    "tier1": "Tier 1",
    "tier2": "Tier 2",
    "tier3": "Tier 3",
    "tier1Desc": "Basic everyday words learned through speech",
    "tier1Examples": "dog, run, happy, big",
    "tier1Teaching": "Rarely need instruction",
    "tier2Desc": "High-utility academic words across domains",
    "tier2Examples": "analyze, contrast, evidence, reluctant",
    "tier2Teaching": "Worth teaching explicitly",
    "tier3Desc": "Low-frequency, domain-specific jargon",
    "tier3Examples": "isotope, photosynthesis, accipitriformes",
    "tier3Teaching": "Teach only when needed for specific content",
    "beckTitle": "Beck Tiers (Isabel Beck's Vocabulary Framework)",
    "sweetSpot": "Sweet Spot",
    "tierLabel": "Tier {{tier}}",
    "examplesLabel": "e.g. {{examples}}"
  },
  "vocabLists": {
    "title": "Vocabulary Lists",
    "subtitle": "Curated collections of vocabulary words for study",
    "browseDictionary": "Browse Dictionary",
    "noLists": "No vocabulary lists available yet.",
    "backToLists": "Back to Lists",
    "source": "Source:",
    "viewAllLists": "View All Lists",
    "emptyList": "This list is empty."
  },
  "questions": {
    "bank": "Question Bank",
    "questionsIn": "questions in",
    "import": "Import",
    "createQuestion": "Create Question",
    "searchPlaceholder": "Search questions...",
    "mcq": "MCQ",
    "shortAnswer": "Short Answer",
    "essay": "Essay",
    "longResponse": "Long Response",
    "fillBlank": "Fill Blank",
    "tableSort": "Table Sort",
    "ai": "AI",
    "manual": "Manual",
    "imported": "Imported",
    "testfit": "TestFit",
    "includeCourse": "Include Course",
    "noQuestions": "No questions in this lesson yet",
    "noQuestionsMatch": "No questions match your filters",
    "importQuestions": "Import Questions",
    "stimulus": "Stimulus",
    "noStimulus": "No Stimulus",
    "answer": "Answer:",
    "questionOf": "Question {{current}} of {{total}}",
    "questionType": "Question Type",
    "switchTypeWarning": "Switching type will discard MCQ options. Continue?",
    "prompt": "Prompt",
    "promptPlaceholder": "Write your question here...",
    "options": "Options",
    "correctAnswer": "Correct Answer",
    "expectedAnswer": "Expected answer (optional)",
    "linkToStimulus": "Link to Stimulus (optional)",
    "advanced": "Advanced",
    "bloomsLevel": "Bloom's Level",
    "remember": "remember",
    "understand": "understand",
    "apply": "apply",
    "analyze": "analyze",
    "evaluate": "evaluate",
    "createBloom": "create",
    "explanation": "Explanation",
    "explanationPlaceholder": "Why is this the correct answer?",
    "modelAnswer": "Model Answer",
    "modelAnswerPlaceholder": "Exemplary student response",
    "rubric": "Rubric",
    "rubricPlaceholder": "Scoring criteria",
    "correctOption": "Correct answer",
    "markCorrect": "Mark as correct",
    "addOption": "Add option",
    "dropFile": "Drop a .docx or .pdf here, or click to browse",
    "pasteQuestions": "Paste your questions here...",
    "lines": "lines",
    "process": "Process →"
  },
  "questionImport": {
    "reviewTitle": "Review Imported Questions",
    "questionsFound": "questions found",
    "fromPastedText": "from pasted text",
    "noModelAnswers": "No model answers found",
    "questionsMissingAnswers": "questions missing answers",
    "generateModelAnswers": "Generate model answers from the activity's reading material.",
    "generateButton": "Generate Model Answers",
    "extractingText": "Extracting text...",
    "analyzingQuestions": "Analyzing questions...",
    "usuallyFewSeconds": "This usually takes a few seconds",
    "importFailed": "Import failed",
    "goBack": "Go Back",
    "selectedQuestion": "Selected Question",
    "readingSource": "Reading source material...",
    "matchingQuestions": "Matching questions to passages...",
    "draftingAnswers": "Drafting model answers...",
    "citingEvidence": "Citing textual evidence...",
    "reviewingQuality": "Reviewing answer quality..."
  },
  "atlas": {
    "quizzesTitle": "Map Quizzes",
    "quizzesSubtitle": "Pick a quiz to test your geography knowledge.",
    "questionCount_one": "{{count}} question",
    "questionCount_other": "{{count}} questions",
    "startQuiz": "Start quiz",
    "politicalMap": "Political Map",
    "apWorldHistory": "AP World History: Modern",
    "savedMaps": "Saved Maps",
    "saveMap": "Save Map",
    "loadingMapData": "Loading map data...",
    "showLegend": "Show Legend",
    "zoomIn": "Zoom in",
    "zoomOut": "Zoom out",
    "resetView": "Reset view",
    "legend": "Legend",
    "hide": "Hide",
    "saveConfig": "Save Map Configuration",
    "saveConfigHelp": "Please enter a name for this map configuration.",
    "nameField": "Name",
    "namePlaceholder": "e.g., Mongol Expansion Map",
    "region": "Region",
    "noneSelected": "None selected",
    "yearRange": "Year Range",
    "ce": "CE",
    "bce": "BCE",
    "focusYear": "Focus Year",
    "attachToCourse": "Attach to Course (optional)",
    "noCourse": "No course",
    "overlays": "Overlays",
    "tradeRoutes": "Trade Routes",
    "cities": "Cities",
    "battles": "Battles",
    "events": "Events",
    "migrations": "Migrations"
  },
  "teacherAtlasMapSets": {
    "title": "Map Sets",
    "subtitle": "Curated GeoJSON collections for topic-specific Atlas study.",
    "newMapSet": "New map set",
    "noMapSets": "No map sets yet. Create one to start curating a topic like \"German Unification.\"",
    "createFirstMapSet": "Create your first map set",
    "shared": "shared",
    "viewMapSet": "View map set"
  },
  "feedback": {
    "showThinking": "Show thinking process",
    "hideThinking": "Hide",
    "answerChoices": "Answer Choices",
    "correctMark": "Correct",
    "incorrectMark": "Your answer",
    "yourAnswer": "(Your answer)",
    "yourCategorization": "Your Categorization",
    "noItemsPlaced": "No items placed",
    "missing": "Missing:",
    "yourResponse": "Your Response",
    "noResponse": "No response",
    "modelAnswer": "Model Answer",
    "feedbackLabel": "Feedback",
    "skillsAssessed": "Skills Assessed"
  },
  "homework": {
    "title": "Homework",
    "viewBank": "View Bank",
    "noItems": "No homework items yet",
    "addActivity": "Add Activity",
    "addFromBank": "Add from Bank",
    "chooseActivity": "Choose an activity",
    "noActivities": "No activities available",
    "addToHomework": "Add to Homework",
    "untitled": "Untitled",
    "fromLesson": "From {{title}}",
    "questionsCount": "{{count}} questions",
    "stimulusLabel": "Stimulus: {{title}}",
    "instructionsPlaceholder": "Teacher instructions (e.g., 'Finish questions 3-5')",
    "editInstructions": "Edit instructions",
    "removeFromHomework": "Remove from homework",
    "removeConfirm": "Remove this item from homework? The original content won't be deleted.",
    "answeredCount": "{{answered}}/{{total}} answered",
    "submitting": "Submitting...",
    "submitHomework": "Submit Homework",
    "readingPassage": "Reading Passage"
  },
  "stimulus": {
    "minRead": "{{minutes}} min read",
    "offlineTitle": "Want to read offline?",
    "offlineDescription": "Print this article for better focus. When ready, return here to continue.",
    "iveReadIt": "I've Read It",
    "finishedReading": "Finished reading?",
    "continueToQuestions": "Continue to Questions",
    "contentFrom": "Content from {{domain}}",
    "openExternal": "Open External Resource",
    "instructions": "Instructions: ",
    "externalHelp": "Click the button above to open the resource in a new tab. Take your time to read and understand the content, then return here to continue.",
    "pdfNotAvailable": "PDF not available",
    "pageOf": "Page {{current}} of {{total}}",
    "failedToLoadPdf": "Failed to load PDF",
    "tryDownloading": "Try downloading the PDF instead",
    "loadingPdf": "Loading PDF...",
    "videoContent": "Video content",
    "videoUnavailable": "Video content unavailable",
    "imageContent": "Image content",
    "imageUnavailable": "Image unavailable",
    "expand": "Expand",
    "uploadedHandwritten": "Uploaded handwritten work",
    "handwrittenPrompt": "Have handwritten notes? Drop an image or click to upload"
  },
  "ui": {
    "switchToLight": "Switch to light mode",
    "switchToDark": "Switch to dark mode"
  },
  "sessionMap": {
    "unanswered": "Unanswered",
    "answered": "Answered",
    "currentlyViewing": "Currently Viewing",
    "noStudentsYet": "No students have joined yet. Share the join code to get started.",
    "noApprovedQuestions": "No approved questions in this activity."
  },
  "lessonFlow": {
    "priorHw": "Prior HW",
    "hw": "HW",
    "read": "Read",
    "live": "Live",
    "essay": "Essay",
    "assess": "Assess",
    "vocab": "Vocab",
    "pres": "Pres.",
    "assessment": "Assessment"
  },
  "wordHighlight": {
    "addToMyList": "+ Add to my list",
    "addToList": "+ Add to {{name}}",
    "addToCourseList": "+ Add to course list...",
    "noCourseListsYet": "No course lists yet"
  },
  "tableCompletion": {
    "wordBank": "Word Bank",
    "allItemsPlaced": "All items placed",
    "dropItemsHere": "Drop items here",
    "itemsPlaced": "{{placed}} of {{total}} items placed",
    "removeItem": "Remove {{item}}"
  },
  "essayResponse": {
    "placeholder": "Write your essay here...",
    "bold": "Bold",
    "italic": "Italic",
    "heading": "Heading",
    "quote": "Quote",
    "markdownSupported": "Markdown supported",
    "wordsExpected": "Essay • {{min}}-{{max}} words expected",
    "wordCount": "{{count}} words"
  },
  "flash": {
    "pleaseLogIn": "Please log in to continue",
    "accessDenied": "Access denied",
    "invalidCredentials": "Invalid email or password",
    "loggedOut": "You have been logged out",
    "profileUpdated": "Profile updated",
    "courseCreated": "Course created",
    "courseUpdated": "Course updated",
    "courseDeleted": "Course deleted",
    "unsupportedFileType": "Unsupported file type.",
    "fileUploaded": "File uploaded. Processing will complete shortly.",
    "bookRemoved": "Book removed from course.",
    "studentEnrolled": "Student enrolled",
    "studentRemoved": "Student removed",
    "lessonCreated": "Lesson created",
    "lessonUpdated": "Lesson updated",
    "lessonDeleted": "Lesson deleted",
    "chapterNotAssociated": "Chapter is not associated with this lesson or its neighbors",
    "activityAlreadyExists": "An activity for this chapter already exists",
    "activityCreatedFromChapter": "Activity created from chapter",
    "activityUpdated": "Activity updated",
    "activityDeleted": "Activity deleted",
    "unitCreated": "Unit created",
    "unitUpdated": "Unit updated",
    "unitDeleted": "Unit deleted",
    "noAssociatedBook": "This unit has no associated book",
    "chapterPlanSaved": "Chapter plan saved",
    "stimulusAdded": "Stimulus added",
    "noStimulusFound": "No stimulus found",
    "stimulusUpdated": "Stimulus updated",
    "stimulusRemoved": "Stimulus removed",
    "addStimulusFirst": "Add a stimulus first",
    "importStarted": "Import started. Questions will be ready for review shortly.",
    "importStartedNotify": "Import started. We'll notify you when questions are ready for review.",
    "questionsImported": "{{count}} questions imported successfully.",
    "itemUpdated": "Item updated.",
    "itemDeleted": "Item deleted.",
    "cantDeleteInUse": "This item can't be deleted because it's used in an active course.",
    "alreadyInLibrary": "You already have \"{{title}}\" in your library.",
    "uploadedProcessing": "{{type}} uploaded. Processing will complete shortly.",
    "linkSaved": "Link saved. Processing will complete shortly.",
    "lessonAssigned": "Lesson assigned to {{title}}",
    "assessmentAlreadyInLesson": "This assessment is already in this lesson",
    "assessmentAdded": "Assessment added to lesson",
    "assessmentNotFound": "Assessment not found or not ready",
    "removedFromLesson": "Removed from lesson",
    "noActiveTrial": "No active trial.",
    "userCreated": "User {{name}} created successfully",
    "userUpdated": "User {{name}} updated successfully",
    "userEmailExists": "A user with that email already exists",
    "teacherAccountCreated": "Teacher account created for {{email}}. Email invitation coming soon."
  }
}
